import {
    CONNECT_SCALE_SOCKET, DISCONNECT_SCALE_SOCKET, CONNECTED_SCALE_SOCKET, SET_SCALEWEIGHT_INFO
} from '../constants/action-types';

export const connectScaleSocket = () => ({ type: CONNECT_SCALE_SOCKET });

export const connectedScaleSocket = isConnected => ({ type: CONNECTED_SCALE_SOCKET, isConnected });

export const disconnectScaleSocket = () => ({ type: DISCONNECT_SCALE_SOCKET });

export const socketError = error => ({ type: DISCONNECT_SCALE_SOCKET, error });

export const setScaleWeightInfo = scaleInfo => ({ type: SET_SCALEWEIGHT_INFO, scaleInfo });